
const matrixData = [
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "Customer privacy protection",
            icon : "social.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "Vision 2030 adherence",
            icon : "governance.svg",
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "Governance framework",
            icon : "governance.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "Ethics",
            icon : "governance.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "Employment",
            icon : "social.svg",
        },
        {
            type : "three",
            content : "Local communities",
            icon : "social.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : "Economic performance",
            icon : "economic.svg",
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "Diversity",
            icon : "social.svg",
        },
        {
            type : "three",
            content : "Sustainable finance",
            icon : "environment.svg",
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "Social assessment of suppliers",
            icon : "social.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "Indirect economic impacts",
            icon : "economic.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        {
            type : "three",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "two",
            content : "Emissions",
            icon : "environment.svg",
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : "Biodiversity impacts",
            icon : "environment.svg",
        },
        {
            type : "one",
            content : "Procurement practices",
            icon : "economic.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "Waste management",
            icon : "environment.svg",
        },
        {
            type : "one",
            content : "Training and education",
            icon : "social.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "Water consumption",
            icon : "environment.svg",
        },
        {
            type : "two",
            content : null,
            icon : null,
        },
        
    ],
    [
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : "Occupational health and safety",
            icon : "social.svg",
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        {
            type : "one",
            content : null,
            icon : null,
        },
        
    ],
]

export default matrixData;